import { Link } from 'react-router-dom';
import detalheImg from 'src/img/detalhe.svg';

const linkNotAvailable = (
  <td>
    <a className="change-link">
      <div className="change-link"> - </div>
    </a>
  </td>
);

const componentLink = row => (
  <td>
    <Link
      to={{ pathname: `/product/${row.product_id}/variant/${row.id}` }}
      className="change-link"
    >
      <div className="change-link text-center">
        <img className="d-block m-auto" src={detalheImg} alt="Detalhes" />
        Detalhes
      </div>
    </Link>
  </td>
);

const renderVariantLink = row =>
  row.id ? componentLink(row) : linkNotAvailable;

const getVariantsDetailsLinkColumn = {
  cell: renderVariantLink,
  right: true,
};

export default getVariantsDetailsLinkColumn;
